// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Vqid","title":"Header_title__8Unvo","side":"Header_side__1FLes"};